import { responsive } from '@/utils';

import { StyledDataRowDivider } from './dataRowDivider/dataRowDivider.styles.ts';

type DataRowDividerProps = {
  /** Margin above and below the divider. */
  spacing?: string;
};

export const DataRowDivider = ({ spacing = responsive.spacing.xlarge }: DataRowDividerProps) => (
  <StyledDataRowDivider orientation='horizontal' color='soft_strong' $spacing={spacing} />
);
